import { AnimatePresence } from 'framer-motion'
import { withTranslation } from 'react-i18next'

import { useExternalDevices } from '@/lib/hooks'
import Button from '@/ui/Button'
import Loader from '@/ui/Loader'

import useCheckout from '../../hooks/useCheckout'
import CheckoutStep from '../CheckoutStep'
import ErrorModal from '../ErrorModal'
import PaymentMethod from '../PaymentMethod'
import { PaymentWrapper } from './Payment.styles'

const Payment = ({ t }) => {
  const { createOrder, paymentMethod, setPaymentMethod, setCurrentStep, status, error, clearError } = useCheckout()
  const { data: externalDevices } = useExternalDevices()
  const terminal = externalDevices?.find(o => o.type === 'PAYMENT_TERMINAL')

  const paymentOptions = [
    {
      label: 'creditCard',
      value: 'creditCard',
      show: !!terminal
    },
    {
      label: 'cash',
      value: 'cash',
      show: true
    }
  ]

  const handlePayment = () => {
    if (paymentMethod === 'creditCard') {
      setCurrentStep('TERMINAL')
    } else {
      createOrder()
        .unwrap()
        .then(({ type }) => {
          setCurrentStep('SUMMARY')
        })
        .catch(() => {})
    }
  }

  return (
    <CheckoutStep
      title={t('choosePaymentMethod')}
      action={
        <Button onClick={handlePayment} size="xl">
          {t('makeOrder')}
        </Button>
      }
    >
      <PaymentWrapper>
        {paymentOptions
          .filter(o => o.show)
          .map(({ label, value }) => (
            <PaymentMethod
              key={value}
              label={label}
              value={value}
              onClick={() => setPaymentMethod(value)}
              active={paymentMethod === value}
            />
          ))}
      </PaymentWrapper>
      <AnimatePresence>{status === 'LOADING' && <Loader />}</AnimatePresence>
      {status === 'ERROR' && <ErrorModal title={t('errorOccurred')} description={error} onClose={() => clearError()} />}
    </CheckoutStep>
  )
}

export default withTranslation()(Payment)
